import { createSelector } from '@reduxjs/toolkit'
import { getArrayFromCollection } from '@opallabs/lambda'
import { PhaseItem } from '../../../../types'
import { getPhaseItems } from '../../getters/entities/phaseItems'

export const selectPhaseItems = createSelector([getPhaseItems], (phaseItems) =>
  getArrayFromCollection<PhaseItem>(phaseItems)
)
